import { useLocation } from 'react-router-dom';
import { useControls } from 'src/api/hooks/useControlData';

export const generateBreadcrumbItems = () => {
  const location = useLocation();
  const { data, isLoading } = useControls();
  const controls = data?.controls ?? [];

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const items = [{ text: 'Controllership Hub', href: '/' }];

  if (isLoading) {
    return items;
  }

  if (pathSegments.length >= 2) {
    const controlId = pathSegments[1];
    const control = controls.find((c) => c.controlId === controlId);

    if (control && !isLoading) {
      items.push({
        text: `${control.controlName}`,
        href: `/${pathSegments[0]}/${controlId}`,
      });

      // If we're on a sub-page (summary, etc)
      if (pathSegments[2]) {
        items.push({
          text: `${control.controlSubTitle}`,
          href: location.pathname,
        });
      }
      return items;
    }
  }

  let currentPath = '';
  pathSegments.forEach((segment) => {
    currentPath += `/${segment}`;
    items.push({
      text: segment.charAt(0).toUpperCase() + segment.slice(1),
      href: currentPath,
    });
  });

  return items;
};
